import * as React from 'react';
import {Link} from 'react-router-dom';
import Spinner from 'react-spinkit';

export default class ListItemComponent extends React.Component {
  render() {
    let content = (
      <span className="list-item-wrapper">
        {this.props.loading && <span className="list-item-icon">
          <Spinner fadeIn="none" name="wave" color="#3d3c3f" />
        </span>}
        {this.props.icon && <i className="list-item-icon material-icons">{this.props.icon}</i>}
        <span className="list-item-content">
          {this.props.primaryText && <span className="list-item-primary-text">{this.props.primaryText}</span>}
          {this.props.secondaryText && <span className="list-item-secondary-text">{this.props.secondaryText}</span>}
        </span>
        {this.props.actions || null}
      </span>
    );

    return (
      <li className="list-item" id={this.props.id}>
        {this.props.route
          ? <Link to={this.props.route}>{content}</Link>
          : content}
        {this.props.children || null}
      </li>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/list/list-item/list-item-component.js